import { startLinkedApp } from './linkedAppSso';
import React from "react"
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { AuthProvider } from './context/AuthContext'
import { ThemeProvider } from './context/ThemeContext'
startLinkedApp(() => {
ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </BrowserRouter>
, document.getElementById('root'));
}, '/auth/sso-handoff');


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

